var NgSettingsInterceptor = (function () {
    function NgSettingsInterceptor($q, $cacheFactory) {
        var _this = this;
        this.$q = $q;
        this.request = function (config) {
            if (config.url.indexOf('ng-settings/') > -1) {
                config.cache = _this.cache;
            }
            return config || _this.$q.when(config);
        };
        this.cache = $cacheFactory('ng-settings');
    }
    NgSettingsInterceptor.Factory = function ($q, $cacheFactory) {
        return new NgSettingsInterceptor($q, $cacheFactory);
    };
    return NgSettingsInterceptor;
}());
export { NgSettingsInterceptor };
